import React from 'react';

interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  color?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  trend,
  color = '#333',
}) => {
  const formatValue = (val: string | number): string => {
    if (typeof val === 'number') {
      if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
      if (val >= 1000) return `${(val / 1000).toFixed(1)}K`;
      return val.toFixed(2);
    }
    return val;
  };

  return (
    <div
      style={{
        padding: '20px',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: `2px solid ${color}`,
        minHeight: '120px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
        {title}
      </div>
      <div
        style={{
          fontSize: '32px',
          fontWeight: 'bold',
          color: color,
          marginBottom: '4px',
        }}
      >
        {formatValue(value)}
        {typeof value === 'number' && title.includes('%') && '%'}
      </div>
      {subtitle && (
        <div style={{ fontSize: '12px', color: '#999' }}>{subtitle}</div>
      )}
      {trend && (
        <div
          style={{
            fontSize: '12px',
            color: trend.isPositive ? '#00C851' : '#ff4444',
            marginTop: '8px',
          }}
        >
          {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value).toFixed(1)}%
        </div>
      )}
    </div>
  );
};
